// ClickCircle design tokens.
// Single source of truth for colours, spacing, radii and type. Prefer these
// over hardcoded hex values so a brand tweak is a one-file change.

const theme = {
  color: {
    // Brand
    brand: "#4F46E5",
    brandDark: "#3730A3",
    brandDeep: "#1E1B4B",
    brandSoft: "#EEF0FF",
    accent: "#C4B5FD",
    accentSoft: "#F5F3FF",

    // Surfaces
    bg: "#F7F7FB",
    surface: "#FFFFFF",
    surfaceAlt: "#F8F9FB",
    border: "#E4E8EC",
    borderStrong: "#D0D5DD",

    // Text
    text: "#101828",
    textMuted: "#667085",
    textFaint: "#98A2B3",
    onDark: "#EAF2F0",
    onDarkMuted: "#8FA9A3",

    // Status
    success: "#027A48",
    successSoft: "#ECFDF3",
    danger: "#B42318",
    dangerSoft: "#FEF3F2",
    warning: "#B54708",
    warningSoft: "#FFFAEB",
    info: "#175CD3",
    infoSoft: "#EFF8FF",
  },

  // Ordered series colours for charts — distinct hues, not three shades of one.
  chart: ["#4F46E5", "#7C3AED", "#0EA5E9", "#F59E0B", "#EC4899"],

  radius: {
    sm: "8px",
    md: "12px",
    lg: "16px",
    pill: "999px",
  },

  shadow: {
    sm: "0 1px 2px rgba(16, 24, 40, 0.05)",
    md: "0 4px 12px rgba(16, 24, 40, 0.06)",
    lg: "0 12px 32px rgba(16, 24, 40, 0.10)",
  },

  space: (n) => `${n * 4}px`,

  layout: {
    sidebar: "256px",
    sidebarCollapsed: "76px",
    header: "68px",
    content: "1440px",
    breakpoint: "820px",
  },

  font: {
    h1: "28px",
    h2: "22px",
    h3: "18px",
    body: "14px",
    small: "13px",
    tiny: "12px",
  },
};

export default theme;
